module.exports = __webpack_public_path__ + "img/icon-uncheckedred.02ba93b6.svg";